<template>
  <div class="waiting-next-slide">
    <div
      class="icon-slide-end"
    >
      <div class="icon-wrapper">
        <HeroImage width="111" />
      </div>
    </div>
    <div class="title">
      {{ $t("thankScreen") }}
    </div>
    <p v-if="showAhaSlidesCTA && !isWhiteLabelUser" class="des">
      {{ $t('enjoyThisPresentationFooterBanner') }}
    </p>

    <QASessionBtn
      use-button-v2
      v-if="isQnaAllSlides"
      class="max-w-351px mb-3.5 mx-auto"
    />

    <Buttonv2
      class="max-w-351px"
      size="lg"
      block
      @click="handleClickOnButtonCTA"
      v-if="showAhaSlidesCTA && !isWhiteLabelUser"
    >
      <span>{{ $t('getStartedWithAhaSlides') }}</span>
      <AhaSvg
        name="arrow-no-tail"
        view-box="0 0 8 14"
      />
    </Buttonv2>

    <div v-if="isWhiteLabelUser" class="text-exit--block">
      <a href="#" class="text-exit" @click="handleExitPresentation">
        {{ $t('exitAndVote') }}
      </a>
    </div>
  </div>
</template>
<script>
import HeroImage from '@/components/common/HeroImage.vue'
import Buttonv2 from '@/components/UI/Buttonv2.vue'
import QASessionBtn from '@/components/QASessionBtn.vue'
import AhaSvg from 'storybook-presenter/UI/Svg'

export default {
  components: {
    AhaSvg,
    HeroImage,
    Buttonv2,
    QASessionBtn,
  },
  props: {
    presenterUrl: {
      type: String,
      default: '',
    },
    isWhiteLabelUser: {
      type: Boolean,
      default: false,
    },
    handleClickOnButtonCTA: {
      type: Function,
      default: () => {},
    },
    handleExitPresentation: {
      type: Function,
      default: () => {},
    },
    isQnaAllSlides: {
      type: Boolean,
      default: false,
    },
    showAhaSlidesCTA: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.icon-wrapper {
  margin-bottom: 15px;
}

.title {
  font-weight: bold;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 8px;
}

.des {
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 0;
  line-height: 1.5;
}

.max-w-351px {
  max-width: 351px;
}

.text-exit--block {
  margin-top: 10px;
}

.text-exit {
  font-size: 14px;
  cursor: pointer;
  color: $primary-color;
  &:hover {
    color: $primary-hover-color;
  }
}
</style>
